const printableNutritionTranslations = {
  meals: {
    title: "الوجبات",
    mealNumber: {
      meal1: "الوجبة الأولى",
      meal2: "الوجبة الثانية",
      meal3: "الوجبة الثالثة",
      meal4: "الوجبة الرابعة",
    },
  },
  snacks: "الوجبات الخفيفة",
  loading: "يرجى الانتظار بينما نقوم بتحميل قائمة اليوم...",
};

export default printableNutritionTranslations;
